import * as GooglePhoneNumber from 'google-libphonenumber';

import { logError } from '@helpers/Loggers';

const PhoneNumberFormat = GooglePhoneNumber.PhoneNumberFormat;
const PhoneNumberUtil = GooglePhoneNumber.PhoneNumberUtil.getInstance();

// TODO: can we specify default region more intelligently?
const DEFAULT_REGION = 'us';

export function parsePhoneNumber(number: string, region?: string) {
  return PhoneNumberUtil.parse(number, region ? region : DEFAULT_REGION);
}

export function formatPhoneNumberToE164(phoneNumber: GooglePhoneNumber.PhoneNumber) {
  return PhoneNumberUtil.format(phoneNumber, PhoneNumberFormat.E164);
}

export function isValidPhoneNumber(phoneNumber: GooglePhoneNumber.PhoneNumber) {
  try {
    return PhoneNumberUtil.isValidNumber(phoneNumber);
  } catch {
    return false;
  }
}

export function validatePhoneNumber(
  phoneNumber: string,
  countryCode: string
): { error: string; parsedPhoneNumber: string } {
  if (!phoneNumber) {
    return {
      error: 'Please enter your phone number.',
      parsedPhoneNumber: '',
    };
  }
  const invalidNumberResponse = {
    error: 'Please enter a valid phone number.',
    parsedPhoneNumber: '',
  };
  try {
    const parsedNumber = parsePhoneNumber(phoneNumber, countryCode);
    if (isValidPhoneNumber(parsedNumber)) {
      return {
        error: '',
        parsedPhoneNumber: formatPhoneNumberToE164(parsedNumber),
      };
    } else {
      return invalidNumberResponse;
    }
  } catch (error) {
    logError(error);
    return invalidNumberResponse;
  }
}
